import { StoreShortWithSupplierType } from '@/types'

export default function getSearchRequestParamsFromStores(
  stores: StoreShortWithSupplierType[]
) {
  const groupedBySupplier = stores.reduce(
    (acc, store) => {
      if (!acc[store.supplierId]) {
        acc[store.supplierId] = new Set<number>()
      }
      acc[store.supplierId].add(store.code)
      return acc
    },
    {} as { [supplierId: string]: Set<number> }
  )

  const result: { [key: string]: string } = {}

  for (const supplierId in groupedBySupplier) {
    const codes = [...groupedBySupplier[supplierId]].join(',')
    const formattedKey = `stores.include[${supplierId}]`
    result[formattedKey] = codes
  }

  return result
}
